export default __webpack_public_path__ + "static/media/img11.178a28d4.png";